import styled from 'styled-components';
import { fadeInToFadeOut } from '@savgroup-front-common/core/src/animations/stateAnimation';

export const $ResetPressingContainer = styled.div`
  ${fadeInToFadeOut};
`;
